// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"b14b2f6c","194":"f3c66f57","216":"5d46bf8c","274":"5f8402f5","434":"38cbdfeb","555":"c86a6f41","635":"248860e5","677":"8a2afe22","773":"6a3c68c3","861":"a21f81cb","925":"4f2fe926","986":"96c3dda0"}[chunkId] + ".chunk.js";
};